import { Component } from '@angular/core';

@Component({
  template: `<router-outlet></router-outlet>`,
  selector: 're-conversions-feature',
  standalone: false
})
export class ConversionsFeatureComponent {}
